export default __webpack_public_path__ + "static/media/elephant.3ea59427.png";